import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Card } from 'material-ui/Card';
import compose from 'recompose/compose';
import ViewTitle from '../layout/ViewTitle';
import Title from '../layout/Title';
import { crudGetOne as crudGetOneAction } from 'actions/dataActions';
import DefaultActions from './ShowActions';

import * as notification_utils from '../../routes/notification/utils';

export class Show extends Component {
    componentDidMount() {
        if (this.props.customFetch) {
            this.props.customFetch();
        } else {
            this.props.crudGetOne(this.props.resource, this.props.id, this.props.detailBackendPath, this.props.basePath);
        }
    }

    getBasePath() {
        const { location } = this.props;
        return location.pathname.split('/').slice(0, -2).join('/');
    }

    render() {
        const { actions = <DefaultActions />, title, children, id, data, isLoading, resource } = this.props;
        const basePath = this.props.basePath || this.getBasePath();
        const defaultTitle = `${resource} ${id}`;

        const titleElement = data ? <Title title={title} record={data} defaultTitle={defaultTitle} /> : '';

        let { hasEdit } = this.props;
        // Special case check for Sent or Failed Notification
        // TODO: Find a better way to do this checking
        if (
            resource === 'Notification'
            && data
            && (
                data.status_display === notification_utils.NOTIFICATION_STATUS_NAME[notification_utils.NOTIFICATION_STATUS_SUCCESS] 
                || data.status_display === notification_utils.NOTIFICATION_STATUS_NAME[notification_utils.NOTIFICATION_STATUS_FAILED]
                || data.status_display === notification_utils.NOTIFICATION_STATUS_NAME[notification_utils.NOTIFICATION_STATUS_SENDING]
                || data.status_display === notification_utils.NOTIFICATION_STATUS_NAME[notification_utils.NOTIFICATION_STATUS_RETRYING]
            )
        ) {
            hasEdit = false;
        }

        return (
            <div>
                <Card style={{ opacity: isLoading ? 0.8 : 1 }}>
                    {actions && React.cloneElement(actions, {
                        basePath,
                        editPath: this.props.editPath || '',
                        data,
                        resource,
                        hasEdit,
                    })}
                    <ViewTitle title={titleElement} />
                    {data && React.cloneElement(children, {
                        resource,
                        basePath,
                        record: data,
                    })}
                </Card>
            </div>
        );
    }
}

Show.propTypes = {
    actions: PropTypes.element,
    children: PropTypes.element,
    crudGetOne: PropTypes.func.isRequired,
    data: PropTypes.object,
    hasDelete: PropTypes.bool,
    hasEdit: PropTypes.bool,
    id: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    resource: PropTypes.string.isRequired,
    title: PropTypes.any,
};

function mapStateToProps(state, props) {
    return {
        id: decodeURIComponent(props.match.params.id),
        data: state.admin[props.resource].data[decodeURIComponent(props.match.params.id)],
        isLoading: state.admin.loading > 0,
    };
}

const enhance = compose(
    connect(
        mapStateToProps,
        { crudGetOne: crudGetOneAction },
    ),
);

export default enhance(Show);



// WEBPACK FOOTER //
// ./src/components/detail/Show.js